import axiosInstance from "../api/axiosInstance";

// GET: Promoter payout list
export const fetchPromoterPayouts = (params) =>
  axiosInstance.get("/admin/promoterPayoutList", { params });

// GET: Promoter payout detail (with transactions)
export const getPromoterPayoutDetail = (id) =>
  axiosInstance.get(`/admin/promoterPayoutDetail/${id}`);

// POST: Pay now for pending payout
export const payPromoterPayout = (id) =>
  axiosInstance.post(`/admin/promoterPayNow/${id}`, { id });
